import React from 'react';
import { Wrench, Home, Layers, Shield, Search, Zap } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { services } from '../data/mock';

const iconMap = {
  Wrench,
  Home,
  Layers,
  Shield,
  Search,
  Zap
};

export const Services = () => {
  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-secondary mb-4">
            Our Roofing <span className="text-primary">Services</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            From residential to commercial, we provide comprehensive roofing solutions
            tailored to Central Florida's unique climate and your specific needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="service-card border-0 shadow-lg hover:shadow-2xl overflow-hidden group"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                  <div className="absolute bottom-4 left-4">
                    <div className="w-14 h-14 bg-primary rounded-full flex items-center justify-center icon-bounce">
                      <IconComponent className="w-7 h-7 text-white" />
                    </div>
                  </div>
                </div>
                <CardContent className="p-6">
                  <h3 className="text-2xl font-bold text-secondary mb-3">
                    {service.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="text-center mt-12">
          <p className="text-lg text-muted-foreground">
            Don't see what you're looking for?{' '}
            <button
              onClick={() =>
                document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })
              }
              className="text-primary font-semibold hover:underline"
            >
              Contact us
            </button>{' '}
            for custom roofing solutions.
          </p>
        </div>
      </div>
    </section>
  );
};
